import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";

const UserSetting = ({
    userSettingMutate,
    userSettingLoading,
    setUserSetting,
    selectedData,

}) => {
  const SubmitHandler = (values) => {
    if (!values.bondPlan) {
      toast.error("Please enter your payuMid");
      return;
    }else if(!values.isBondAvailable) {
      toast.error("Please enter your payuKey");
      return;
    }
    userSettingMutate(values);
  };
  

  const formik = useFormik({
    initialValues: {
      bondPlan: selectedData?.bondPlan || "",
      isBondAvailable: selectedData?.isBondAvailable || "",
       clientId: selectedData?.clientId || "",
       propId: selectedData?.propId || "",
    },
    validationSchema: Yup.object().shape({
      bondPlan: Yup.string().required("Select Rental Bond"),
      isBondAvailable: Yup.string().required("Select isBondAvailable")

    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setUserSetting}>
      {userSettingLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>User Setting</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              {/* <CombineInputGroup> */}
                <InputGroup>
                  <Label htmlFor="isBondAvailable">Rental Bond Availabe</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="isBondAvailable"
                      id="isBondAvailable"
                      value={formik.values.isBondAvailable}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                    >
                      {/* isBondAvailable */}
                      <MenuItem value="1">Inactive</MenuItem>
                      <MenuItem value="2">Active</MenuItem>
                    </Select>
                    {formik.touched.isBondAvailable &&
                      formik.errors.isBondAvailable && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.isBondAvailable}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="isBondAvailable">Bond Plan</Label>
                  <FieldWrapper $select={true}>
                    <Select
                    // bondPlan
                      name="bondPlan"
                      id="bondPlan"
                      value={formik.values.bondPlan}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                      disabled={formik.values.isBondAvailable === "1"} 
                    >
                      <MenuItem value="1">Prepaid</MenuItem>
                      <MenuItem value="2">Postpaid</MenuItem>
                    </Select>
                    {formik.touched.bondPlan &&
                      formik.errors.bondPlan && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.bondPlan}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default UserSetting;
